
namespace TabAurous.HR {

    @Serenity.Decorators.registerClass()
    export class LeavePolicyDetailsGrid extends Serenity.EntityGrid<LeavePolicyDetailsRow, any> {
        protected getColumnsKey() { return 'HR.LeavePolicyDetails'; }
        protected getDialogType() { return LeavePolicyDetailsDialog; }
        protected getIdProperty() { return LeavePolicyDetailsRow.idProperty; }
        protected getInsertPermission() { return LeavePolicyDetailsRow.insertPermission; }
        protected getLocalTextPrefix() { return LeavePolicyDetailsRow.localTextPrefix; }
        protected getService() { return LeavePolicyDetailsService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}